module.exports = __webpack_public_path__ + "media/images/payment_methods/mybank-279fc0c1f2889523d1ffdefd74076549.svg";